module.exports = __webpack_public_path__ + "static/media/settingsActiveIcon.250f8286.svg";